import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    // "modal",
    // "promoteButton",
    // "recipientCheckbox",
    // "sendNotificationButton",
    // "viewButton",
    // "notificationRecipients",
    "saveButton",
  ];
  static values = {
    template: String,
  };

  connect() {
    // console.log("Hello, Stories Interview Template Tag Controller here!", this.element);
  }

  addTag(event) {
    event.preventDefault();
    Turbo.visit(`/interview_templates/${this.templateValue}/tags/new`, {
      frame: "new-tag-form",
    });
  }

  markResponsesTableAsReloadable(event) {
    document.querySelector('#responses-table').setAttribute('reloadcontent', 'true');
  }

  removeNewRow(event) {
    event.preventDefault();
    event.target.closest(".row").remove();
  }
}
